import validator from 'validator';

export const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === 'string' && value.trim().length === 0);

export const idEmptyValidation = value =>
  !isEmpty(value) ? undefined : 'This field is required';

export const idNumberValidation = value =>
  value > 0 && value < 10000000000
    ? undefined
    : 'Please enter a valid ID number.';

export const emailValidation = value =>
  isEmpty(value) || validator.isEmail(value)
    ? undefined
    : 'Please enter a valid email.';

export const phoneValidation = value =>
  isEmpty(value) ||
  ((value.charAt(0) === '+' &&
    validator.isNumeric(value.substring(1)) &&
    value.length > 6 &&
    value.length < 18) ||
    (validator.isNumeric(value) &&
      value.charAt(0) === '0' &&
      value.length > 5 &&
      value.length < 15))
    ? undefined
    : 'Please enter a valid phone number (contains only numbers and started with 0 or +).';

export const dateValidation = value =>
  isEmpty(value) ||
  /^(?:[1-9]\d{3}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[1-9]\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00)-02-29)T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:Z|[+-][01]\d:[0-5]\d)$/.test(
    value
  )
    ? undefined
    : 'Please enter a ISO 8601 date format (e.g. 2020-10-01T12:00:00+07:00).';
